// extracted by mini-css-extract-plugin
export default {"tupacGrid":"jo-z","tupacHeader":"ko-z","tupacHeader2":"lo-z","tupacMenu":"mo-z","tupacMenu2":"no-z","tupacMain":"oo-z","tupacMain2":"po-z"};